// src/utils/imageUtils.js

const IMAGE_VARIANTS_FRONTEND_CONFIG = {
    card: { suffix: "_card", format: "webp" },
    blur: { suffix: "_blur", format: "webp" },
    full: { suffix: "_full", format: "webp" },
    original: {
        isDirectKey: true
    }
};

export const getImageUrl = (originalImageKey, variantName = 'card', options = {}) => {
    if (!originalImageKey) {
        const { w = 300, h = 200, text = "Ni slike" } = options;
        return `https://via.placeholder.com/${w}x${h}.webp?text=${encodeURIComponent(text)}`;
    }

    const r2PublicUrlBase = process.env.REACT_APP_R2_PUBLIC_URL_BASE;
    if (!r2PublicUrlBase) {
        console.error("REACT_APP_R2_PUBLIC_URL_BASE ni definiran.");
        const { w = 300, h = 200, text = "API Napaka" } = options;
        return `https://via.placeholder.com/${w}x${h}.webp?text=${encodeURIComponent(text)}`;
    }

    const variantConfig = IMAGE_VARIANTS_FRONTEND_CONFIG[variantName];

    if (!variantConfig) {
        console.warn(`Neznana varianta slike: ${variantName}. Uporabljam originalni ključ kot fallback.`);
        // TUKAJ JE originalImageKey že ključ (npr. abc.jpg), zato ga moramo encodati
        return `${r2PublicUrlBase}/${encodeURIComponent(originalImageKey)}`;
    }

    if (variantConfig.isDirectKey) {
        // originalImageKey je ključ originalne datoteke (npr. "ime_slike.jpg")
        // Tudi tega moramo encodati, preden ga dodamo v URL.
        return `${r2PublicUrlBase}/${encodeURIComponent(originalImageKey)}`;
    }

    // --- SPREMEMBA TUKAJ ---
    // Najprej delamo z originalImageKey, ki še NI URL-enkodan.
    let baseKeyWithoutExtension = originalImageKey;
    const lastDotIndex = originalImageKey.lastIndexOf('.');

    if (lastDotIndex !== -1) {
        // Odstranimo originalno končnico
        baseKeyWithoutExtension = originalImageKey.substring(0, lastDotIndex);
    }
    // Zdaj imamo npr. "a58f0cea-5408-44f1-a598-bfc66939ec68_MAKITA1"
    // ali "moj oglas/slika 1"

    // Sestavimo nov ključ za varianto
    const variantKey = `${baseKeyWithoutExtension}${variantConfig.suffix}.${variantConfig.format}`;
    // Npr. "a58f0cea-5408-44f1-a598-bfc66939ec68_MAKITA1_card.webp"
    // ali "moj oglas/slika 1_card.webp"

    // Šele zdaj celoten sestavljen ključ URL-enkodamo
    const encodedVariantKey = encodeURIComponent(variantKey);

    const fullUrl = `${r2PublicUrlBase}/${encodedVariantKey}`;
    // console.log(`Generated URL for ${originalImageKey} (${variantName}): ${fullUrl}`); // Za debugging
    return fullUrl;
};